import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.billing-accounts')
  .factory('ConsolidateBillingOrdersAPI', ConsolidateBillingOrdersAPI);

function ConsolidateBillingOrdersAPI(): BringozApi {
  return {
    base: `/consolidatedBillingOrder`,
    infiniteScroll: {
      address: `/consolidatedBillingOrder`,
      cmd: 'GET'
    },
    actions: {
      getOne: {
        address: '{id}',
        cmd: 'GET',
        updateable: false
      },
      create: {
        address: '',
        cmd: 'PUT',
        updateable: false
      },
      update: {
        address: '{id}/edit',
        cmd: 'POST',
        updateable: false
      },
      bulkEdit: {
        address: 'edit',
        cmd: 'POST',
        updateable: false
      },
      addBillingOrders: {
        address: '{id}/addBillingOrders',
        cmd: 'POST',
        updateable: false
      },
      removeBillingOrders: {
        address: '{id}/removeBillingOrders',
        cmd: 'POST',
        updateable: false
      },
      exportPDF: {
        address: 'actions/sendToEmail',
        cmd: 'POST',
        updateable: false
      },
      exportCSV: {
        address: '{id}/actions/export',
        cmd: 'POST',
        updateable: false
      },
      exportTable: {
        address: 'actions/export',
        cmd: 'POST',
        updateable: false
      },
      createInvoice: {
        address: '{id}/actions/createInvoice',
        cmd: 'POST',
        updateable: false
      },
      refund: {
        address: '{id}/actions/refund',
        cmd: 'POST',
        updateable: false
      },
      payManually: {
        address: '{id}/actions/payManually',
        cmd: 'POST',
        updateable: false
      },
      resetPayManually : {
        address: 'actions/resetManuallyPaidProforma',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}
